export { default as HDWallet } from './hdwallet';
